import { TmrBaseResource } from 'stylewhere/api'

export class SortingGroups extends TmrBaseResource {
  static endpoint = 'api/v1/sortinggroups' //logistics/
}
